import { Container, useTheme } from '@mui/material';
import React, { useCallback, useMemo, useRef, useState } from 'react'
import DataGridV2 from '../../../components/DataGridV2';
import { apps, LOCAL_STORAGE_GRID_KEYS } from '../../../_constants';
import { formatDate, getLocalStorageItem, setLocalStorageItem } from '../../../_helpers';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import { INITIAL_ROW_SELECTION_MODEL } from '../../../components/DataGridV2/constants';
import useGridDataModalHandler from '../../../_hooks/useGridDataModalHandler';
import { getQuestionnaireColumns } from './utils';
import { getQuestionnaires } from '../../../apis/questionnaireApis';

const QuestionnairesGrid = () => {
   const classes = useStyles();
    const app = useSelector((state) => state.app);
    const theme = useTheme()
    const apiRef = useGridApiRef();
    const muiTableRef = useRef();
    const { t, i18n } = useTranslation();
    const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
    const keyPrefix =   app === apps.constructionQuality ? "CONSTRUCTION_QUALITY" : "GENERAL";
     const {
        loading,
        loadedRows,
        sortModel,
        handleSort,
        filterModel,
        handleFilter,
        handleSearch,
        handleCellSort,
        searchText,
        getAllRecords,
        totalRecords,
        paginationModel,
        handleCellFilter,
        onPaginationModelChange,
        getAllExportRecords
      } = useGridDataModalHandler({
        additionalParams: { app },
        apiCall: getQuestionnaires,
        rowIdentifier: "id",
        sortModal: getLocalStorageItem(
          LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_COLUMN_SORT[keyPrefix], undefined
        ),
        filterModal: getLocalStorageItem(
          LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_COLUMN_FILTER[keyPrefix], undefined
        ),
        paginationModel: getLocalStorageItem(
          LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_PAGINATION[keyPrefix], undefined
        ),
        searchText: getLocalStorageItem(
          LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_SEARCH_TEXT[keyPrefix], ""
        ),
        dateTimeFields: ["createdOn", "modifiedOn"]
      });

       const getQuestionnaireForPrintAndDownload = async ({ selectedColumnsNames = [], isAllSelected = true,idsToExport=[] }) => {
          const { data: { results } } = await (selectedColumnsNames.length > 0 
            ? getAllExportRecords({
                additionalObjectPayload: { exportColumns: selectedColumnsNames },
                additionalCondition: isAllSelected ? [] : [{
                  field: "id",
                  operator: "isAnyOf",
                  value: [...idsToExport],
                }]
              }) 
            : getAllRecords());
          
          const data = results?.map((result) => {
            const { ...rest } = result || {};
            const plannedDate = result?.["plannedDate"] ? formatDate(new Date(result["plannedDate"]), true, "-", true) : "-";
            const createdOn = result?.["createdOn"] ? formatDate(new Date(result["createdOn"]), true, "-", true) : "-";
            const completedOn = result?.["completedOn"] ? formatDate(new Date(result["completedOn"]), true, "-", true) : "-";

            return {
              ...rest,
              plannedDate,
              createdOn,
              completedOn
             
            };
          });
          return data;
        };
       
        const onFilterModelChange = useCallback((newFilterMModel) => {
            handleFilter(newFilterMModel, (newFilterMModel) => {
              setLocalStorageItem(
                LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_COLUMN_FILTER[keyPrefix],
                newFilterMModel
              );
            })
          }, [handleFilter])

  const columns = useMemo(() => {
    return getQuestionnaireColumns({  t, handleCellSort, handleCellFilter,i18n, apiRef,keyPrefix,theme });
  }, [t,handleCellSort ,handleCellFilter,theme]);


  const getToolbarProps = useMemo(() => {
    const toolbarProps = {
      apiRef: apiRef,
      columns: columns,
      title: t("constructionquality.questionnaire"),
      totalRecords: totalRecords,
      getData: getQuestionnaireForPrintAndDownload,
      handleSearch: (value) => {
        handleSearch(value, (value) => {
          setLocalStorageItem(
            LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_SEARCH_TEXT[keyPrefix],
            value
          );
        });
      },
      searchText: searchText,
      selectedRows: rowSelectionModel,

    };
    return toolbarProps;
  }, [apiRef, columns,  handleSearch, rowSelectionModel, searchText,  t, totalRecords]);
  return (
      <Container maxWidth={false} className={classes.mainContainer}>
            <DataGridV2
              localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_SEARCH_TEXT[keyPrefix]}
              localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_COLUMN_ORDER[keyPrefix]}
              localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_COLUMN_WIDTH[keyPrefix]}
              localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_COLUMN_VISIBILITY[keyPrefix]}
              rowSelectionModel={rowSelectionModel}
              checkboxSelection
              columns={columns}
              ref={muiTableRef}
              apiRef={apiRef}
              loading={loading}
              toolbarProps={getToolbarProps}
              rowCount={totalRecords}
              rows={loadedRows}
              pagination
              paginationModel={paginationModel}
              onPaginationModelChange={(paginationModal) =>
                onPaginationModelChange(paginationModal, (paginationModal) => {
                  setLocalStorageItem(
                    LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_PAGINATION[keyPrefix],
                    paginationModal
                  );
                })}
              sortModel={sortModel}
              onSortModelChange={(newSortModel) =>
                handleSort(newSortModel, (newSortModal) => {
                  setLocalStorageItem(
                    LOCAL_STORAGE_GRID_KEYS.QUESTIONNAIRE_COLUMN_SORT[keyPrefix],
                    newSortModal
                  );
                })
              }
              filterMode="server"
              paginationMode="server"
              onFilterModelChange={onFilterModelChange}
              onRowSelectionModelChange={(newRowSelectionModel) => {
                setRowSelectionModel(newRowSelectionModel);
              }}
              {...(!!filterModel && { filterModel })}
            />
          </Container>
  )
}
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: "100%",
    width: "100%",
    overflow: "auto",
    padding: 0,

  },
}));
export default QuestionnairesGrid
